import { navigate, Link } from 'gatsby'
import React, { useContext, useEffect, useState } from 'react'
import Cart from '../../../assets/cart.svg'
import CartMobile from '../../../assets/cart-mobile.svg'
import AppContext from '../../../context/context'
import { intl } from '../../../../common/i18n'
import route from '../../../utils/route'
import styles from './index.module.scss'
import {
  selectNumeroProductos,
  selectImporteTotal,
} from '../../../context/selectors/cestaSelectors'

export default function CestaHeaderIcon({ isMobile }) {
  const { cestaState } = useContext(AppContext)

  const numberOfProducts = selectNumeroProductos(cestaState)
  const totalPrice = selectImporteTotal(cestaState)

 
  const goToCesta = () => {
    if (!cestaState.products.length) {
      return
    }
    navigate(route('cesta.solicitud'))
  }
  return (
    <>
      {!cestaState.loading && (
        <div className={styles.cesta_header_icon_wrapper}>
          <Link
            to={
              !cestaState.products.length
                ? route('index')
                : route('cesta.solicitud')
            }
            className={
              numberOfProducts === 0 ? styles.cesta_disabled : styles.cesta
            }>
            {isMobile && (
              <CartMobile />  
            )}
            {!isMobile && (
              <Cart />  
            )}
            <div className={styles.icon_badge}>
              <div className={styles.cesta_badge}>
                {Number(numberOfProducts)}{' '}
              </div>
            </div>
          </Link>
        </div>
      )}
    </>
  )
}
